import request from '@/utils/http';
export const getServiceTasksList = (data) => {
    return request({
        url: `/api-otp/vdServiceTasks`,
        method: 'post',
        data
    });
};

export const taskIssue = (data) => {
    return request({
        url: `/api-otp/vd/issue`,
        method: 'post',
        data
    });
};

export const cancel = (data) => {
    return request({
        url: `/api-otp/vd/separateWarehouse/cancel`,
        method: 'post',
        data
    });
};